import {
	ICollection,
	IConnection,
	IEmailConfig,
	IEmailField,
	IFormsConfig,
	IItemType,
	INewRequestFormField,
	IColor,
	IRequestTableFormField,
	ISavedRequestFormField,
	ISettings,
	IUserIdField,
	IPersonolize,
	IAdditional,
	IItemOfTypeLevels,
	IToolTipText,
} from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { v4 } from "uuid"
import { TReactSelectOption } from "../../Interfaces/ExternalComponentsInterfaces"

export const defaultUserSelectedForm: IFormsConfig | undefined = undefined
export const defaultIOTLevels: IItemOfTypeLevels = {
	itemOfTypeId: "",
	isPicklistFirstSetSecond: false,
	levelOneEnabled: false,
	levelTwoEnabled: false,
	firstLevelFieldNameLV: "",
	firstLevelFieldNameEN: "",
	secondLevelFieldNameLV: "",
	secondLevelFieldNameEN: "",
	picklistFieldId: "",
	stringFieldId: "",
}
export const defaultUserFormTooltip: IToolTipText = {
	textEN: "",
	textLV: "",
	isRichText: false,
}
export const defaultFieldData: {
	newRequestForm: INewRequestFormField
	requestTable: IRequestTableFormField
	savedRequestForm: ISavedRequestFormField
	collections: ICollection
} = {
	newRequestForm: {
		charLimit: "",
		fieldType: "STRING",
		isConditional: false,
		isMultilineField: false,
		isRequired: false,
		excludedItemOfTypeValues: [],
		mainFieldKey: "",
		mainFieldLabel: "",
		nameLV: "",
		nameEN: "",
		excludedPickListItemValues: [],
		predicateFieldKey: "",
		predicateValues: [],
		tooltip: defaultUserFormTooltip,
		itemOfTypeBooleanFieldId: "",
		itemOfTypeBooleanItemId: "",
		itemOfTypeUserFieldId: "",
		itemOfTypeUserItemId: "",
		itemOfTypeLevels: defaultIOTLevels,
	},

	requestTable: {
		mainFieldKey: "",
		mainFieldLabel: "",
		nameEN: "",
		nameLV: "",
		searchable: false,
		sortable: false,
		isDefaultSortField: false,
		defaultSortOrder: "ascending",
		type: "",
	},
	savedRequestForm: {
		mainFieldKey: "",
		nameEN: "",
		nameLV: "",
		mainFieldLabel: "",
		fieldType: "",
	},
	collections: {
		picklistFieldId: null,
		picklistLabel: null,
		picklistValue: null,
		projectId: "",
		projectName: "",
		folderId: "",
		folderName: "",
		responsibleValue: null,
		responsibleField: null
	},
}

export const defaultConnectionFormData: IConnection = {
	tool: "jama",
	url: "",
	userName: "",
	password: "",
}
export const defaultItemTypeFormData: IItemType = {
	id: "",
	name: "",
}
export const defaultUserIdFieldFormData: IUserIdField = {
	fieldId: "",
	name: "",
}
export const defaultNewRequestFormData: INewRequestFormField[] = []
export const defaultRequestTableFormData: IRequestTableFormField[] = []
export const defaultSavedRequestFormData: ISavedRequestFormField[] = []
export const defaultCollectionsFormData: ICollection[] = [defaultFieldData["collections"]]
export const defaultPersonalizationFormData: IPersonolize = {
	colorButton: "#267ce7",
	colorButtonText: "#ffffff",
	colorHeader: "#ffffff",
	colorHeaderText: "#267ce7",
	bigLogo: false,
}
export const defaultEmailConfig: IEmailConfig = {
	smtpHost: "",
	smtpPort: "25",
	smtpUser: "",
	smtpPass: "",
	emailFrom: "",
	isSecureConnection: false,
	isAnonymous: false,
	isCompleted: false,
}

export const defaultNewCommentEmailSelectData: TReactSelectOption = {
	value: "email.newCommentLabel",
	label: "",
}
export const defaultEmailFormData: IEmailField = {
	sendEmail: false,
	emailType: [defaultNewCommentEmailSelectData],
	notificationText: "",
}

export const defaultAdditionalInfo: IAdditional = {
	welcomeTextLV: "",
	welcomeTextEN: "",
	toolTipTexts: {
		userSideAttachments: {
			textLV: undefined,
			textEN: undefined,
			isRichText: false,
		},
	},
	submitText: {
		notificationTextLV: "",
		notificationTextEN: "",
		isEnabled: false,
	},
	cookieBar: {
		textLV: "",
		textEN: "",
		isRichText: false,
	},
	
}

export const defaultFormData: {
	newRequestForm: INewRequestFormField[]
	requestTable: IRequestTableFormField[]
	savedRequestForm: ISavedRequestFormField[]
	collections: ICollection[]
	personalize: IColor
} = {
	newRequestForm: defaultNewRequestFormData,
	requestTable: defaultRequestTableFormData,
	savedRequestForm: defaultSavedRequestFormData,
	collections: defaultCollectionsFormData,
	personalize: defaultPersonalizationFormData,
}
export const getDefaultFormData = (
	additionalInformation: Partial<IFormsConfig> = {}
): IFormsConfig => {
	return {
		id: v4(),
		name: "",
		position: 0,
		isActive: false,
		itemType: defaultItemTypeFormData,
		userIdField: defaultUserIdFieldFormData,
		userEmailField: defaultUserIdFieldFormData,
		userMobField: defaultUserIdFieldFormData,
		userDepField: defaultUserIdFieldFormData,
		userNameField: defaultUserIdFieldFormData,
		collections: defaultCollectionsFormData,
		newRequestForm: defaultNewRequestFormData,
		requestTable: defaultRequestTableFormData,
		savedRequestForm: defaultSavedRequestFormData,
		...additionalInformation,
	}
}

export const defaultSettingsData: ISettings = {
	connection: defaultConnectionFormData,
	formsConfigs: [],
	personalize: defaultPersonalizationFormData,
	emailField: defaultEmailFormData,
	additionalInfo: defaultAdditionalInfo,
}

export const defaultConfigData: IFormsConfig = {
	id: v4(),
	name: "",
	position: 0,
	isActive: false,
	itemType: defaultItemTypeFormData,
	userIdField: defaultUserIdFieldFormData,
	userEmailField: defaultUserIdFieldFormData,
	userMobField: defaultUserIdFieldFormData,
	userDepField: defaultUserIdFieldFormData,
	userNameField: defaultUserIdFieldFormData,
	collections: defaultCollectionsFormData,
	newRequestForm: defaultNewRequestFormData,
	requestTable: defaultRequestTableFormData,
	savedRequestForm: defaultSavedRequestFormData,
}

export interface IIOTLevels {
	frstLvlOptions: TReactSelectOption[] | undefined
	frstLvlValue: string | undefined
	scndLvlOptions: TReactSelectOption[] | undefined
	scndLvlValue: string | undefined
	thrdLvlOptions: TReactSelectOption[] | undefined
}

export const defaultUserFormItemOfTypeLevels: IIOTLevels = {
	frstLvlOptions: undefined,
	frstLvlValue: undefined,
	scndLvlOptions: undefined,
	scndLvlValue: undefined,
	thrdLvlOptions: undefined,
}
